module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xzxx-detail"
  }, [_c('div', {
    staticClass: "detail-box ques-info"
  }, [_c('p', {
    ref: "titleBox",
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.detailInfo.TITLE) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.detailInfo.IS_REPLY == '1') ? _c('img', {
    staticClass: "statusImg",
    attrs: {
      "src": require("../../../static/assets/reply.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.detailInfo.IS_REPLY == '0') ? _c('img', {
    staticClass: "statusImg",
    attrs: {
      "src": require("../../../static/assets/unreply.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/assets/ask.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.MAIL_TYPE_DISPLAY))]), _vm._v(" "), (_vm.detailInfo.CREATE_TIME) ? _c('span', [_vm._v(_vm._s(_vm.detailInfo.CREATE_TIME))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-text",
    domProps: {
      "innerHTML": _vm._s(_vm.detailInfo.CONTENT)
    }
  }), _vm._v(" "), _vm._l((_vm.detailInfo.LETTER_FJ), function(att, index) {
    return _c('attachment-cell', {
      key: index,
      attrs: {
        "option": att
      }
    })
  })], 2)]), _vm._v(" "), (_vm.detailInfo.IS_REPLY == '1') ? _c('div', {
    staticClass: "detail-box answ-info"
  }, [_c('p', {
    staticClass: "sub-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/assets/answer.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("回复")]), _vm._v(" "), (_vm.detailInfo.REPLY_TIME) ? _c('span', [_vm._v(_vm._s(_vm.detailInfo.REPLY_TIME))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-text",
    domProps: {
      "innerHTML": _vm._s(_vm.detailInfo.REPLY_CONTENT)
    }
  }), _vm._v(" "), _vm._l((_vm.detailInfo.REPLY_FJ), function(att, index) {
    return _c('attachment-cell', {
      key: index,
      attrs: {
        "option": att
      }
    })
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b4e4e48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobileDetail/index.vue
// module id = 568
// module chunks = 0